import {useEffect} from "react";
import { useHistory } from 'react-router-dom';

const RedirectToService = () => {
    const history = useHistory();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const product = urlParams.get('product');
        const locale = urlParams.get('locale');
        //
        localStorage.removeItem('product');
        localStorage.removeItem('validList');
        localStorage.removeItem('attrList');
        localStorage.removeItem('sum');
        if (product) {
            return history.push(`/services/server-iran/server-order?id=${product}`,  {
                id: product
            });
        } else {
            return history.push('/');
        }
    }, [])
    return (
        <h1></h1>
    )
}

export default RedirectToService;
